module.exports = __webpack_public_path__ + "img/75614.62707e5d.svg";